/**
* 登录模块
* 说明：整合了随手记，卡牛，随管家，云之家，web登录
*/
import BaseAuth from './client/base'

import SuishoujiAuth from './client/suishouji'
import CardniuAuth from './client/cardniu'
// import SuiguanjiaAuth from './client/suiguanjia'
// import YunzhijiaAuth from './client/yunzhijia'
import WebAuth from './client/web'

// import { openAccount } from './account/account'
import { loginTypes, accountTypes } from './dict'

// 登录
export const login = (options) => {
  const suishoujiAuth = new SuishoujiAuth(options)
  const cardniuAuth = new CardniuAuth(options)
  // const suiguanjiaAuth = new SuiguanjiaAuth(options)
  // const yunzhijiaAuth = new YunzhijiaAuth(options)
  const webAuth = new WebAuth(options)

  suishoujiAuth.login()
  cardniuAuth.login()
  // suiguanjiaAuth.login()
  webAuth.login()
  // yunzhijiaAuth.login()
}

// 获取用户token
// 目前只能在随手记、卡牛中获取用户的token
export const getToken = () => {
  const suishoujiAuth = new SuishoujiAuth()
  const cardniuAuth = new CardniuAuth()
  // const suiguanjiaAuth = new SuiguanjiaAuth()
  // const yunzhijiaAuth = new YunzhijiaAuth()

  return suishoujiAuth.getToken() ||
         cardniuAuth.getToken() ||
         webAuth.getToken()
         //  suiguanjiaAuth.getToken() ||
        //  yunzhijiaAuth.getToken() ||
}

// 请求登录接口
export const requestLoginApi = (params, options) => {
  const baseAuth = new BaseAuth(options)
  baseAuth.requestLoginApi(params, options)
}

// 开户
// 登录类型
// 开户类型
export {
  // openAccount,
  loginTypes,
  accountTypes,
}

export default {
  login,
  getToken,
  requestLoginApi,
  // openAccount,
  loginTypes,
  accountTypes,
}
